import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { AuthContext } from 'providers/AuthProvider'
import React, { useState } from 'react'
import { Customer, useUserQuery } from 'shopify/api'
import FullModalContainer from './FullModalContainer'
import RFQModal from './RFQModal'
import WifButton from './WifButton'

interface Search404Props {
  explorePageHref: string
}

const Search404: React.FC<Search404Props> = ({ explorePageHref }) => {
  const { t } = useTranslation()
  const router = useRouter()
  const { authToken } = React.useContext(AuthContext)
  const [isCustomOrderModalOpen, setIsCustomOrderModalOpen] = useState(false)

  const { loading: userLoading, data: userData } = useUserQuery({
    variables: {
      token: authToken!,
    },
    fetchPolicy: 'network-only',
  })

  return (
    <div className='mt-28 '>
      <div className=' flex flex-col items-center justify-center text-center mx-10'>
        <Image
          src='/icons/ic-mto-404.svg'
          width={140}
          height={140}
          style={{ objectFit: 'contain' }}
          alt='Not Found'
        />
        <p className='mt-5 text-sm font-normal'>{t('mto:404_description')}</p>
        <div className='mt-8 w-60 relative m-auto text-sm '>
          <WifButton
            handleClick={() => {
              if (!authToken) return router.push('/login?errorAuth=true')
              setIsCustomOrderModalOpen(true)
            }}
            id='custom-order'
            text={t('mto:create_custom_order')}
            iconSrc='/icons/ic-document.svg'
          />
          <div className='mt-9 text-wif-orange text-sm font-bold'>
            <Link href={explorePageHref}>{t('mto:explore_again')}</Link>
          </div>
        </div>
      </div>

      {isCustomOrderModalOpen && (
        <FullModalContainer
          id='customer-order-mto-modal'
          title={t('mto:custom_order.title')}
          onClose={() => {
            setIsCustomOrderModalOpen(false)
          }}
        >
          <RFQModal
            customer={userData?.customer as Customer}
            isCustomOrder={true}
            onClose={() => {
              setIsCustomOrderModalOpen(false)
            }}
          />
        </FullModalContainer>
      )}
    </div>
  )
}

export default Search404
